import { render, staticRenderFns } from "./MonthlySocsoMaybank.vue?vue&type=template&id=5019e638&scoped=true"
import script from "./MonthlySocsoMaybank.vue?vue&type=script&lang=js"
export * from "./MonthlySocsoMaybank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5019e638",
  null
  
)

export default component.exports